/** @module polyfills */

/**
 * Ensures support for Fetch API
 */
export function fetch() {
    if (!('fetch' in window)) {
        // use pseudo-dynamic import to make package free from side-effects
        import(/* webpackMode: "eager" */ 'whatwg-fetch');
    }
}
